import type { AppConfig, DocumentConfiguration } from '@cognite/apm-config';

export const DEFAULT_IDM_DOCUMENTS_CONFIG = {
  description: 'metadata.description',
  title: 'name',
  type: 'mimeType',
};

export const getDocumentConfiguration = (
  isIdm: boolean,
  appConfig?: AppConfig
): DocumentConfiguration | undefined => {
  if (isIdm) {
    return DEFAULT_IDM_DOCUMENTS_CONFIG;
  }

  return appConfig?.featureConfiguration?.documents;
};
